export default __webpack_public_path__ + "static/media/640_business01-es-mobile.4c968bc8.png";